import { style } from 'typestyle';
import { zHeroCarouselActive, zHeroCarouselInactive } from './z';
export const transitionQuickEase = '0.125s ease-in-out';

export const transitionGroupSlide = () => ({
  transitionAppearTimeout: 300,
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    appear: style({
      opacity: 0.01,
      transform: 'translate3d(20px, 0, 0)',
    }),
    appearActive: style({
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
      transition: `all ${transitionQuickEase}`
    }),
    enter: style({
      opacity: 0.01,
      transform: 'translate3d(20px, 0, 0)',
    }),
    enterActive: style({
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
      transition: `all ${transitionQuickEase}`
    }),
    leave: style({
      opacity: 1,
      transform: 'translate3d(0, 0, 0)',
    }),
    leaveActive: style({
      opacity: 0.01,
      transform: 'translate3d(-20px, 0, 0)',
      transition: `all ${transitionQuickEase}`
    })
  }
});

export const transitionGroupCarousel = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    enter: style({
      opacity: 0.01,
    }),
    enterActive: style({
      opacity: 1,
      transition: `opacity ${transitionQuickEase}`
    }),
    leave: style({
      opacity: 1,
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: `opacity ${transitionQuickEase}`
    })
  }
});

export const transitionGroupHero = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 600,
  transitionName: {
    enter: style({
      opacity: 0.01,
      zIndex: zHeroCarouselActive,
    }),
    enterActive: style({
      opacity: 1,
      zIndex: zHeroCarouselActive,
      transition: `opacity ${transitionQuickEase}`
    }),
    leave: style({
      opacity: 1,
      zIndex: zHeroCarouselInactive,
    }),
    leaveActive: style({
      opacity: 0.01,
      zIndex: zHeroCarouselInactive,
      transition: `opacity ${transitionQuickEase} 0.3s`
    })
  }
});

export const transitionModal = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    enter: style({
      opacity: 0.01,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,-5px,0)'
        }
      }
    }),
    enterActive: style({
      opacity: 1,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)',
          transition: `transform ${transitionQuickEase}`,
        }
      }
    }),
    leave: style({
      opacity: 1,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)'
        }
      }
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,-5px,0)',
          transition: `transform ${transitionQuickEase}`,
        }
      }
    })
  }
});

export const transitionDropDrawer = () => ({
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionName: {
    enter: style({
      opacity: 0.01,
      $nest: {
        '&> div': {
          height: 'translate3d(0,-5px,0)'
        }
      }
    }),
    enterActive: style({
      opacity: 1,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)',
          transition: `transform ${transitionQuickEase}`,
        }
      }
    }),
    leave: style({
      opacity: 1,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,0,0)'
        }
      }
    }),
    leaveActive: style({
      opacity: 0.01,
      transition: `opacity ${transitionQuickEase}`,
      $nest: {
        '&> div': {
          transform: 'translate3d(0,-5px,0)',
          transition: `transform ${transitionQuickEase}`,
        }
      }
    })
  }
});